import { useQuery } from '@tanstack/react-query';
import { customInstance } from '@/common/infrastructure/http/apiClient';
import { mapPreviewContextDto, type PreviewContextApiDto } from '@/document-types/application/mappers/mapPreviewContextDto';
import type { DocumentContext } from '@/document-render/domain/DocumentContext';
import type { DocumentTypeRef } from '@/document-types/domain/types/DocumentType';

export const previewScenarioContextQueryKey = (ref: DocumentTypeRef | undefined, scenarioKey: string | null | undefined) =>
  ['document-builder', 'preview-scenario-context', ref?.applicationKey, ref?.moduleKey, ref?.documentTypeKey, scenarioKey] as const;

export const usePreviewScenarioContext = (ref?: DocumentTypeRef, scenarioKey?: string | null) => {
  const enabled = !!ref?.applicationKey && !!ref?.moduleKey && !!ref?.documentTypeKey && !!scenarioKey;

  return useQuery({
    queryKey: previewScenarioContextQueryKey(ref, scenarioKey),
    enabled,
    queryFn: async (): Promise<DocumentContext> => {
      if (!ref || !scenarioKey) throw new Error('DocumentTypeRef and scenarioKey are required');

      const url = `/api/pdf-templates/v1/document-types/by-keys/${ref.applicationKey}/${ref.moduleKey}/${ref.documentTypeKey}/preview-scenarios/${scenarioKey}`;
      const raw = await customInstance<PreviewContextApiDto>({ url, method: 'GET' });
      return mapPreviewContextDto(raw);
    },
    staleTime: 1000 * 60 * 10
  });
};
